const ITEMS = [
  "INTERIOR PAINTING",
  "EXTERIOR PAINTING",
  "CABINET REFINISHING",
  "FENCE & DECK STAINING",
  "COMMERCIAL & RESIDENTIAL",
  "FREE ESTIMATES",
  "RENO · SPARKS · CARSON CITY",
];

const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee-section"
      className="relative overflow-hidden border-y border-gold/15 bg-navy-dark py-5"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap font-mono text-[11px] tracking-[0.35em] text-white/45">
            {item}
            <span className="text-gold">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
